import { useEffect, useState } from "react";
import { THIS_BUILD } from "./net/built.ts";

type Health = { status?: string; commit?: string | null };
const A_COMMIT = /^[0-9a-f]{40}$/;
const PUBLICATION_ATTEMPTS = 120;
const sleep = (ms: number) => new Promise<void>((resolve) => globalThis.setTimeout(resolve, ms));

export function isNewer(mine: string | null, deployed: string | null | undefined): boolean {
  if (!mine || !deployed) return false;
  return mine !== deployed;
}

let ready = false;
const readers = new Set<() => void>();

function tellThePage(): void {
  for (const reader of [...readers]) reader();
}

export function useUpdateReady(): boolean {
  const [is, setIs] = useState(ready);
  useEffect(() => {
    const reader = () => setIs(ready);
    readers.add(reader);
    reader();
    return () => {
      readers.delete(reader);
    };
  }, []);
  return is;
}

export async function askWhatIsDeployed(
  mine: string | null = THIS_BUILD,
  publicationAttempts = PUBLICATION_ATTEMPTS,
): Promise<boolean> {
  if (!mine) return false;
  try {
    const answer = await fetch("/health", { cache: "no-store", credentials: "same-origin" });
    if (!answer.ok) return ready;
    const said = (await answer.json()) as Health;
    if (said.status !== "ok" || !isNewer(mine, said.commit) || !A_COMMIT.test(said.commit ?? "")) {
      return ready;
    }

    for (let attempt = 0; attempt < publicationAttempts && !ready; attempt += 1) {
      const published = await fetch("/rally-build.txt", {
        cache: "no-store",
        credentials: "same-origin",
      });
      const commit = published.ok ? (await published.text()).trim() : null;
      if (commit === said.commit) {
        ready = true;
        tellThePage();
        break;
      }
      if (attempt + 1 < publicationAttempts) await sleep(1_000);
    }
  } catch {}
  return ready;
}

export function reloadNow(): void {
  window.location.reload();
}

export function forgetTheUpdate(): void {
  ready = false;
  tellThePage();
}
